import { useQuery } from 'react-query';
import backend from '../backend';

// tipagem do retorno do request
interface IResponseData {
  usuario: {
    id: number;
    nome: string;
    email: string;
    telefone: string;
    cpf: string;
    cnpj: string;
    status: string;
    ultimo_login: string;
    comissao_certificado: string;
    custo_certificado: string;
    usuario_pai: {
      custo_certificado: string;
      comissao_certificado: string;
    };
  };
  endereco: {
    cep: string;
    logradouro: string;
    numero: string;
    bairro: string;
    uf: string;
    cidade: string;
    complemento: string;
  };
}

// tipagem do que o hook retorna
export type IUsuariosReponse = IResponseData;

async function getUsuario(id: number): Promise<IUsuariosReponse> {
  const response = await backend.get<IResponseData>(`/usuarios/${id}`);
  return response.data;
}

export function useUsuario(id: number) {
  return useQuery(['usuario', id], () => getUsuario(id), {
    staleTime: 1000 * 60 * 5,
    cacheTime: 1000 * 60 * 0,
    // refetchOnWindowFocus: true,
  });
}
